import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  zh: {
    about: '关于我们',
    aboutUs: 'ABOUT US',
    companyName: '星联科技有限公司',
    companyNameShort: '星联科技',
    intro1: '星联科技是一家以高科技创意为核心的国际化技术服务公司，汇聚了众多对软件开发和界面设计有独特创意的高端人才。',
    intro2: '我们致力于为全球企业提供软件开发、网站建设、网页设计、IT 外包、手机应用开发、互联网营销等全方位解决方案。',
    intro3: '公司总部位于欧洲区塞尔维亚，业务遍布欧洲、美洲及中国等多个国家和地区，服务客户涵盖工厂、百货、电商、教育、服装、贸易、制造等众多行业。',
    yearsExperience: '年行业经验',
    clients: '服务客户',
    satisfaction: '客户满意度',
    team: '专业团队',
    banner: '轮播图',
    quotation: '引号',
    advantages: '核心优势',
    whyChooseUs: 'WHY CHOOSE US',
    efficientDelivery: '高效交付',
    efficientDesc: '敏捷开发流程，确保项目按时高质量交付',
    qualityAssurance: '品质保证',
    qualityDesc: '严格的质量控制体系，代码规范，性能优异',
    globalService: '全球服务',
    globalDesc: '多语言支持，7×24 小时全球技术服务',
    security: '安全可靠',
    securityDesc: '企业级安全标准，数据加密，隐私保护',
    services: '业务范围',
    ourServices: 'OUR SERVICES',
    softwareDev: '软件开发',
    softwareDesc: '企业级应用开发、SaaS 平台、业务管理系统定制开发',
    softwareItems: ['企业管理系统', 'CRM/ERP 系统', '数据分析平台'],
    websiteDev: '网站建设',
    websiteDesc: '品牌官网、电商平台、响应式网站设计与开发',
    websiteItems: ['企业官网', '电商平台', '响应式设计'],
    mobileApp: '移动应用',
    mobileDesc: 'iOS/Android原生开发、小程序、跨平台应用',
    mobileItems: ['iOS/Android 应用', '微信小程序', 'Flutter 跨平台'],
    bigData: '大数据服务',
    bigDataDesc: '数据采集、分析、可视化，AI 智能决策支持',
    bigDataItems: ['数据仓库', 'BI 分析', 'AI 算法'],
    uiDesign: 'UI/UX 设计',
    uiDesc: '用户体验设计、界面设计、品牌视觉设计',
    uiItems: ['界面设计', '交互设计', '品牌 VI'],
    itOutsourcing: 'IT 外包服务',
    itOutsourcingDesc: '技术团队外包、项目驻场开发、长期技术顾问',
    itOutsourcingItems: ['人才外包', '项目外包', '技术咨询'],
    cases: '成功案例',
    successCases: 'SUCCESS CASES',
    ecommerce: '电商',
    ecommerceTitle: '欧洲跨境电商平台',
    ecommerceDesc: '日均订单 10 万 +，多语言支持',
    education: '教育',
    educationTitle: '在线教育平台',
    educationDesc: '服务 100 万 + 学员，直播零卡顿',
    factory: '工厂',
    factoryTitle: '智能工厂管理系统',
    factoryDesc: '生产效率提升 30%，实时数据监控',
    departmentStore: '百货',
    departmentStoreTitle: '连锁百货管理系统',
    departmentStoreDesc: '全渠道销售，库存实时同步',
    clientsSection: '合作客户',
    ourClients: 'OUR CLIENTS',
    client1: '世界 500 强企业',
    client2: '知名电商平台',
    client3: '国际酒店集团',
    client4: '重点高校',
    client5: '制造企业',
    client6: '生物医药',
    ctaTitle: '期待与您携手共创未来',
    ctaDesc: '专业的技术团队，为您量身定制数字化解决方案',
    contactUs: '立即咨询',
    language: '语言',
    chinese: '中文',
    english: 'English',
    // HomePage
    homeBanner1Title: '星联科技 - 链接全球 智创未来',
    homeBanner1Content: '专注互联网科技创新，服务遍布欧洲、美洲及中国市场',
    homeBanner2Title: '企业级数字化解决方案专家',
    homeBanner2Content: '从企业官网到电商平台，从小程序到大数据系统，一站式满足您的数字化需求',
    homeBanner3Title: '全球化技术团队 本地化贴心服务',
    homeBanner3Content: '汇聚国际顶尖技术人才，7×24 小时全天候响应，让您的业务永续在线',
    homeBanner4Title: '创新驱动发展 技术引领未来',
    homeBanner4Content: '深耕互联网科技领域多年，以技术创新赋能企业数字化转型',
    homeBusinessTitle: '公司业务介绍',
    homeBusinessSubtitle: 'Our Business',
    homeBusinessDesc: '深耕互联网科技领域 15 年，为企业提供全方位数字化转型解决方案',
    homeCompanyIntro: '星联科技是一家全球化互联网科技企业，业务覆盖欧洲、美洲及中国市场。我们专注于为企业提供数字化转型解决方案，助力客户在数字经济时代构建持久竞争优势。',
    homeCustomerPainPoints: '客户痛点',
    homePainPoint1: '获客成本高：传统渠道获客成本持续攀升，企业增长乏力',
    homePainPoint2: '数字化程度低：业务流程依赖人工，效率低下，错误率高',
    homePainPoint3: '数据孤岛严重：系统林立，数据无法互通，决策缺乏依据',
    homePainPoint4: '用户体验差：服务响应慢，个性化不足，客户流失严重',
    homeSolutions: '解决方案',
    homeSolution1: '企业官网建设：打造专业品牌形象，提升搜索引擎曝光，低成本持续获客',
    homeSolution2: '小程序开发：依托微信生态，即用即走，大幅提升用户转化与复购',
    homeSolution3: '电商平台定制：全渠道营销体系，智能化订单处理，助力业务规模化增长',
    homeSolution4: '大数据系统：打通数据孤岛，实时分析决策，让数据驱动业务增长',
    homeCoreValues: '核心价值',
    homeValue1: '降本增效',
    homeValue2: '业绩增长',
    homeValue3: '体验升级',
    homeValue4: '数据驱动',
    homeValue5: '持续创新',
    homeServiceNetwork: '全球服务网络 | 7×24 小时技术支持 | 全生命周期服务',
    homeServiceDetail: '了解服务详情',
    homeITExpert: '您身边的 IT 专家',
    homeITService: '7x24 小时提供出色的 IT 服务',
    homeContactUs: '联系我们',
    homeCoreServices: '核心服务',
    homeCoreServicesSubtitle: 'CORE SERVICES',
    homeSoftwareDev: '软件开发',
    homeSoftwareDevDesc: '企业级应用、SaaS 平台、业务管理系统定制开发',
    homeSoftwareDevItems: ['企业管理系统', 'CRM/ERP 系统', '数据分析平台'],
    homeWebsiteDev: '网站建设',
    homeWebsiteDevDesc: '品牌官网、电商平台、响应式网站设计与开发',
    homeWebsiteDevItems: ['企业官网', '电商平台', '响应式设计'],
    homeMobileApp: '移动应用',
    homeMobileAppDesc: 'iOS/Android 原生开发、小程序、跨平台应用',
    homeMobileAppItems: ['iOS/Android 应用', '微信小程序', 'Flutter 跨平台'],
    homeBigData: '大数据服务',
    homeBigDataDesc: '数据采集、分析、可视化，AI 智能决策支持',
    homeBigDataItems: ['数据仓库', 'BI 分析', 'AI 算法'],
    homeCustomerTestimonials: '客户评价',
    homeCustomerTestimonialsSubtitle: 'CUSTOMER TESTIMONIALS',
    homeWhyChooseUs: '为什么选择我们的服务',
    homeWhyChooseUsSubtitle: 'THE REASON TO CHOOSING US',
    homeGlobalService: '全球服务网络',
    homeGlobalServiceDesc: '业务覆盖欧洲、美洲及中国\n本地化团队提供贴心服务',
    homeTechnicalStrength: '技术实力雄厚',
    homeTechnicalStrengthDesc: '汇聚行业顶尖技术人才\n多年深耕互联网科技领域',
    home247Support: '7×24 小时响应',
    home247SupportDesc: '全天候技术支持与服务\n快速响应客户需求',
    homeOneStopSolution: '一站式解决方案',
    homeOneStopSolutionDesc: '从策划到开发到运维\n全生命周期服务支持',
    // ContactUs
    contactUs: '联系我们',
    companyName: '星联科技有限公司',
    lookingForward: '期待与您携手共创未来',
    address: '地址',
    addressValue: '欧洲区塞尔维亚',
    phone: '电话',
    phoneValue: '+381698925888',
    email: '邮箱',
    emailValue: 'Starsunion.tech@gmail.com',
    workingHours: '工作时间',
    workingHoursValue: '周一至周五 9:00 - 18:00',
    followUs: '关注我们',
    weixin: '微信',
    weibo: '微博',
    twitter: 'Twitter',
    // Service
    ourServices: '我们的服务',
    ourServicesEn: 'Our Services',
    service1: '企业官网建设',
    service1En: 'Corporate Website',
    service2: '下单小程序开发',
    service2En: 'Ordering Mini Program',
    service3: '电商平台定制',
    service3En: 'E-commerce Platform',
    service4: '大数据管理系统',
    service4En: 'Big Data Management',
    // Software
    softwareProducts: '软件产品',
    software1: '智能仓储系统',
    software1En: 'Smart Warehouse System',
    software2: '电商平台',
    software2En: 'E-commerce Platform',
    software3: '企业官方网站',
    software3En: 'Corporate Official Website',
    software4: '移民咨询平台',
    software4En: 'Immigration Consulting Platform',
    software5: '加密货币交易系统',
    software5En: 'Cryptocurrency Trading System',
    software6: '餐馆下单小程序',
    software6En: 'Restaurant Ordering Mini Program',
    // NewsInformation
    newsInformation: '新闻动态',
    newsInformationEn: 'NEWS & INFORMATION',
    allNews: '全部新闻',
    companyNews: '公司新闻',
    industryNews: '行业动态',
    readMore: '阅读全文 →',
    loadingMore: '加载更多',
    loading: '加载中...',
    noMoreNews: '没有更多新闻了~',
    // Months
    months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    // JobChance
    jobChance: '工作机会',
    phpEngineer: 'PHP工程师',
    jobResponsibilities: '岗位职责',
    jobResponsibility1: '负责公司产品及项目系统的功能开发、代码优化；',
    jobResponsibility2: '负责项目组人员任务的分配与监督，及时解决项目技术问题；',
    jobResponsibility3: '参与系统需求分析与设计，并负责完成PHP核心代码，接口规范制定，架构设计。',
    jobRequirements: '任职要求',
    jobRequirement1: '精通PHP+MySql+Apache开发，精通使用JavaScript、AJAX、JQuery等技术；3年以上WEB应用程序开发经验， 有大型网站或电子商务网站工作经验者优先；',
    jobRequirement2: '熟悉jQuery，具有AJAX、HTML、CSS、JAVASCRIPT等方面的开发经验；',
    jobRequirement3: '熟悉PHP模板技术、框架技术及设计模式，有php框架系统进行开发经验者优先，如：phpcms，dedecms等；',
    jobRequirement4: '精通数据库原理，精通MYSQL、了解Mongo等并有相关关系数据库设计开发经验, 了解Mysql的数据库配置管理、性能优化；',
    jobRequirement5: '熟悉常见的数据结构和算法，具备良好的编程习惯及较强的文档编写能力；',
    jobRequirement6: '熟悉各种WEB缓存技术,熟悉大型网站构架和性能优化；',
    jobRequirement7: '对网站系统架构的部署、搭建、优化、排错等方面有丰富经验，对高负载、大访问量情况下的系统架构有经验者优先。',
    submitResume: '投递简历',
    // Software_smartWarehouse
    smartWarehouse: '智能仓储系统',
    smartWarehouseEn: 'Starlink Smart Warehouse Management System',
    smartWarehouseIntro: '面向现代物流企业的智能化仓储管理平台，集成 IoT、AI、大数据等技术，实现仓储作业的自动化、智能化和可视化，大幅提升仓储运营效率。',
    coreFeatures: '核心功能',
    feature1: '智能入库管理：扫码/RFID 自动识别、智能上架推荐、质检管理',
    feature2: '库存实时监控：库存预警、效期管理、批次追溯、盘点管理',
    feature3: '智能拣货系统：最优路径规划、波次拣货、语音拣货、灯光拣货',
    feature4: '自动化设备集成：AGV 调度、堆垛机控制、输送线对接、机械臂协同',
    feature5: '出库管理：智能复核、自动打包、物流对接、发货追溯',
    feature6: '数据报表：运营分析、KPI 看板、预测分析、决策支持',
    applicationScenarios: '应用场景',
    scenarios: '适用于电商仓储、第三方物流、制造业原料仓、冷链物流、跨境保税仓等各类仓储场景。',
    consultNow: '立即咨询',
    // Software_crossBorderEcommerce
    crossBorderEcommerce: '电商平台',
    crossBorderEcommerceEn: 'Starlink E-commerce Platform',
    crossBorderEcommerceIntro: '一站式电商解决方案，支持多语言、多币种、多仓库，整合支付、物流等环节，助力企业轻松开拓全球市场。',
    feature7: '多语言多币种：支持全球主流语言切换，实时汇率结算',
    feature8: '全球商品管理：多仓库管理、智能库存分配、采购管理',
    feature9: '订单处理：自动审单、智能拆单、合并订单、异常订单处理',
    feature10: '支付对接：PayPal、Stripe、支付宝国际、微信支付全球',
    feature11: '物流追踪：对接 DHL、FedEx、UPS 等国际物流，全程可视化',
    feature12: '智能分析：销售数据、用户行为、库存预警、财务报表',
    scenarios2: '适用于电商 B2C/B2B 平台、海外仓配一体化、进口电商、出口电商等各类贸易场景。',
    // Header Menu
    home: '首页',
    softwareProducts: '软件产品',
    services: '相关服务',
    news: '新闻动态',
    aboutUs: '公司介绍',
    jobs: '工作机会',
    contact: '联系我们',
    smartWarehouse: '智能仓储系统',
    crossBorderEcommerce: '电商平台',
    officialWebsite: '企业官方网站',
    restaurantOrdering: '餐馆下单小程序',
    headerContact: '赶快联系我们吧！',
    headerService: '7x24小时为您服务',
    // Footer
    companyAddress: '地址：欧洲区塞尔维亚',
    companyTel: 'Tel：+381698925888',
    companyEmail: '邮箱：Starsunion.tech@gmail.com',
    companyWechat: '微信号：SerbiaIT',
    copyright: 'Copyright © 2018 - {year} 星联科技 版权所有',
    // CompanyIntroduction
    yearsExperience: '年行业经验',
    // HomePage Customer Reviews
    customer1Title: '某跨国电商集团 CTO',
    customer1Content: '星联科技为我们打造的电商平台稳定高效，支撑了日均百万级的订单处理，技术实力值得信赖。',
    customer2Title: '某知名教育机构负责人',
    customer2Content: '从需求沟通到上线交付，星联团队展现了极高的专业素养，我们的在线教育平台用户体验大幅提升。',
    customer3Title: '某制造企业数字化总监',
    customer3Content: '大数据管理系统帮助我们实现了生产数据的实时监控和智能分析，决策效率提升了 60% 以上。',
    customer4Title: '某连锁零售企业 CEO',
    customer4Content: '企业官网重构后，品牌形象焕然一新，SEO 排名显著提升，客户咨询量增长了近一倍。',
    customer5Title: '某医疗健康平台创始人',
    customer5Content: '星联科技的技术团队响应迅速，问题解决及时，是我们长期稳定的合作伙伴。',
    // NewsInformation
    news1Title: '星联科技完成 B 轮融资，加速全球化布局',
    news1Excerpt: '公司宣布完成 B 轮融资，将重点拓展欧洲、美洲及中国市场，加强技术研发投入，提升全球服务能力。',
    news2Title: '2026 年全球软件开发趋势报告发布',
    news2Excerpt: 'AI 辅助编程、低代码平台、云原生架构成为三大主流趋势，企业需及时调整技术战略。',
    news3Title: '星联科技与某跨国电商集团达成战略合作',
    news3Excerpt: '双方将在电商平台定制、大数据分析等领域展开深度合作，预计年交易额突破 10 亿元。',
    news4Title: '云计算市场规模预计 2027 年突破万亿美元',
    news4Excerpt: '全球云计算市场持续高速增长，企业上云率已超过 80%，混合云成为主流部署方式。',
    news5Title: '人工智能在企业服务领域的应用前景广阔',
    news5Excerpt: '从智能客服到数据分析，AI 技术正在重塑企业服务市场，预计未来三年将增长 5 倍。',
    news6Title: '星联智能小程序平台上线，助力企业数字化转型',
    news6Excerpt: '全新推出的智能小程序平台支持快速搭建下单、电商、预约等多种业务场景。',
    news7Title: '星联科技荣获"年度最佳技术服务商"称号',
    news7Excerpt: '凭借卓越的技术实力和优质的服务，星联科技在数千参选企业中脱颖而出。',
    news8Title: '星联大数据管理系统 V3.0 正式发布',
    news8Excerpt: '新版本支持海量数据实时处理，性能提升 300%，新增 AI 智能分析模块。',
    companyNews: '公司新闻',
    industryNews: '行业动态',
    // ServiceDetail
    featuredServices: '特色服务',
    serviceDetail: '相关服务',
    service1Title: '企业官网建设',
    service1EngTitle: 'Corporate Website',
    service1Content: '<h3>专业企业官网建设服务</h3><p>星联科技为企业提供专业官网建设服务，从品牌策划、UI 设计到技术开发、SEO 优化，打造彰显企业实力、提升品牌形象的官方网站。我们拥有经验丰富的设计和开发团队，已为众多企业打造了高品质的官方网站。</p><h3>服务流程</h3><p>需求沟通 → 方案设计 → UI 设计 → 前端开发 → 后端开发 → 测试上线 → 售后维护。我们提供全流程的服务，确保每个环节都精益求精，为您呈现最完美的作品。</p><h3>服务优势</h3><p>1. 专业设计团队，打造独特品牌形象<br>2. 响应式设计，PC/手机/平板全适配<br>3. SEO 优化，提升搜索引擎排名<br>4. 安全防护，保障网站稳定运行<br>5. 售后维护，7x24 小时技术支持</p>',
    service2Title: '小程序开发',
    service2EngTitle: 'Mini Program Development',
    service2Content: '<h3>专业小程序开发服务</h3><p>星联科技提供微信小程序开发服务，涵盖下单小程序、电商小程序、预约小程序等多种类型。借助微信庞大用户生态，助力企业快速获客、提升转化率。</p><h3>服务流程</h3><p>需求分析 → 原型设计 → UI 设计 → 开发实现 → 测试验收 → 上线发布 → 运营维护。我们采用敏捷开发模式，确保项目高质量交付。</p><h3>服务优势</h3><p>1. 无需下载，即用即走<br>2. 依托微信生态，获客成本低<br>3. 开发周期短，上线快<br>4. 用户体验好，转化率高<br>5. 支持多种营销玩法，助力业务增长</p>',
    service3Title: '电商平台定制',
    service3EngTitle: 'E-commerce Platform',
    service3Content: '<h3>专业电商平台定制服务</h3><p>星联科技为企业提供电商平台定制服务，支持 B2C、B2B、O2O 等多种模式，涵盖商品管理、订单处理、支付对接、物流追踪等全流程功能，助力企业快速搭建专属电商平台。</p><h3>服务流程</h3><p>业务咨询 → 方案设计 → 系统开发 → 集成测试 → 上线部署 → 培训交付 → 运维支持。我们提供一站式电商解决方案，让您无后顾之忧。</p><h3>服务优势</h3><p>1. 支持多商户、多仓库、多币种<br>2. 高并发架构，支撑大促流量<br>3. 全渠道营销工具，提升转化率<br>4. 数据报表，助力经营决策<br>5. 对接主流支付、物流系统</p>',
    service4Title: '大数据系统',
    service4EngTitle: 'Big Data System',
    service4Content: '<h3>专业大数据系统建设服务</h3><p>星联科技为企业提供大数据系统建设服务，涵盖数据采集、存储、处理、分析、可视化全流程，助力企业挖掘数据价值，实现数据驱动决策。</p><h3>服务流程</h3><p>需求调研 → 方案设计 → 系统搭建 → 数据接入 → 分析建模 → 可视化展示 → 培训交付。我们拥有资深大数据团队，为您提供专业的数据服务。</p><h3>服务优势</h3><p>1. 支持多源数据接入<br>2. 分布式存储，海量数据处理<br>3. 实时计算，毫秒级响应<br>4. AI 算法，智能分析预测<br>5. 可视化大屏，数据一目了然</p>',
    // Software_bigData
    bigDataSystem: '大数据管理系统',
    bigDataSystemEn: 'Starlink Big Data Management System',
    bigDataIntro: '面向企业级用户的一站式大数据分析平台，集数据采集、存储、处理、分析、可视化于一体，助力企业挖掘数据价值，驱动智能决策。',
    coreFeatures: '核心功能',
    bigDataFeature1: '多源数据采集：支持数据库、API、日志、IoT 设备等多种数据源接入',
    bigDataFeature2: '海量数据存储：分布式存储架构，支持 PB 级数据高效存储',
    bigDataFeature3: '实时数据处理：流式计算引擎，毫秒级数据处理能力',
    bigDataFeature4: '智能数据分析：内置 AI 算法模型，支持预测分析、异常检测',
    bigDataFeature5: '可视化大屏：丰富的图表组件，支持自定义数据看板',
    bigDataFeature6: '权限管理：细粒度数据权限控制，保障数据安全',
    applicationScenarios: '应用场景',
    bigDataScenarios: '适用于电商数据分析、用户行为追踪、运营监控大屏、金融风控分析、智能制造监控等多种业务场景。',
    consultNow: '立即咨询',
    // Software_cryptoExchange
    cryptoExchange: '加密货币交易系统',
    cryptoExchangeEn: 'Starlink Cryptocurrency Exchange System',
    cryptoExchangeIntro: '安全可靠的加密货币交易平台，支持多种数字货币交易，具备高并发处理能力、多重安全防护、实时行情推送等专业功能。',
    cryptoFeature1: '多币种支持：BTC、ETH、USDT 等主流币种，支持代币发行',
    cryptoFeature2: '交易引擎：高并发撮合、毫秒级响应、支持现货/合约交易',
    cryptoFeature3: '安全防护：冷热钱包隔离、多重签名、DDoS 防护、风控系统',
    cryptoFeature4: '行情系统：实时 K 线、深度图、最新成交、24 小时行情',
    cryptoFeature5: '钱包管理：充币提币、地址管理、资金划转、对账系统',
    cryptoFeature6: '后台管理：用户管理、订单管理、币币管理、财务报表',
    cryptoScenarios: '适用于数字货币交易所、区块链项目方、去中心化金融（DeFi）、数字资产管理等场景。',
    // Software_immigrationConsulting
    immigrationConsulting: '移民咨询平台',
    immigrationConsultingEn: 'Starlink Immigration Consulting Platform',
    immigrationConsultingIntro: '专业移民咨询服务平台，整合全球移民资源，提供移民评估、方案定制、申请进度追踪等一站式服务，助力客户实现移民梦想。',
    immigrationFeature1: '智能评估系统：在线测评、条件评估、成功率预测、方案推荐',
    immigrationFeature2: '项目展示：各国移民项目、政策解读、费用明细、案例展示',
    immigrationFeature3: '客户管理：客户档案、跟进记录、需求分析、标签管理',
    immigrationFeature4: '申请管理：材料清单、进度追踪、时间节点提醒、文档管理',
    immigrationFeature5: '在线咨询：智能客服、专家预约、视频咨询、留言回复',
    immigrationFeature6: '资讯社区：移民资讯、政策解读、经验分享、问答社区',
    immigrationScenarios: '适用于移民中介公司、留学移民机构、海外置业咨询、投资移民服务等场景。',
    // Software_officialWebsite
    officialWebsite: '企业官方网站',
    officialWebsiteEn: 'Starlink Corporate Website Solution',
    officialWebsiteIntro: '专业企业官网建设服务，从品牌策划、UI 设计到技术开发、SEO 优化，打造彰显企业实力、提升品牌形象的官方网站。',
    officialFeature1: '品牌视觉设计：企业 VI 设计、页面 UI 设计、响应式布局',
    officialFeature2: '内容管理系统：新闻发布、产品展示、案例展示、视频中心',
    officialFeature3: '多语言支持：中/英/日/韩等多语言版本，自动语言切换',
    officialFeature4: 'SEO 优化：搜索引擎优化、网站速度优化、移动端适配',
    officialFeature5: '安全防护：SSL 证书、防 SQL 注入、DDoS 防护、数据备份',
    officialFeature6: '数据统计：访问统计、用户行为分析、转化追踪',
    officialScenarios: '适用于各类企业官网、品牌官网、集团门户、产品官网、服务机构官网等品牌形象展示需求。',
    // Software_restaurantOrdering
    restaurantOrdering: '餐馆下单小程序',
    restaurantOrderingEn: 'Starlink Restaurant Ordering Mini Program',
    restaurantOrderingIntro: '智慧餐饮解决方案，支持扫码点餐、在线支付、订单管理、后厨打印等功能，帮助餐厅提升服务效率，改善顾客用餐体验。',
    restaurantFeature1: '扫码点餐：桌台扫码、菜单浏览、规格选择、购物车',
    restaurantFeature2: '智能推荐：热销推荐、套餐搭配、口味偏好、历史订单',
    restaurantFeature3: '在线支付：微信支付、支付宝、会员卡、优惠券',
    restaurantFeature4: '订单管理：订单状态、制作进度、呼叫服务、发票申请',
    restaurantFeature5: '后厨系统：自动接单、分区打印、出餐叫号、退菜处理',
    restaurantFeature6: '后台管理：菜品管理、库存管理、营业报表、会员管理',
    restaurantScenarios: '适用于中餐厅、西餐厅、快餐店、奶茶店、咖啡厅、美食广场等各类餐饮场景。',
    // Software_smartTown
    smartTown: '智能小镇管理系统',
    smartTownEn: 'Starlink Smart Town Management System',
    smartTownIntro: '面向政府及园区管理方的智能化综合管理平台，整合物联网、大数据、AI 等技术，实现小镇/园区的数字化管理、智能化服务和可视化运营。',
    smartTownFeature1: '智慧安防监控：AI 视频分析、人脸识别、车辆管理、异常告警',
    smartTownFeature2: '智能设施管理：设备远程监控、能耗分析、智能巡检、故障预警',
    smartTownFeature3: '企业服务平台：企业入驻管理、政策匹配、诉求受理、数据分析',
    smartTownFeature4: '智慧招商系统：招商项目管理、客户跟进、合同管理、数据分析',
    smartTownFeature5: '综合指挥大屏：全镇数据一屏统览、应急指挥调度、决策支持',
    smartTownFeature6: '移动管理端：随时随地处理事务、接收告警、查看报表',
    smartTownScenarios: '适用于科技园区、产业园区、特色小镇、创业孵化器、物流园区等各类园区的数字化管理和智能化升级。'
  },
  en: {
    about: 'About Us',
    aboutUs: '关于我们',
    companyName: 'Starlink Technology Co., Ltd.',
    companyNameShort: 'Starlink Technology',
    intro1: 'Starlink Technology is an international technology service company with high-tech creativity at its core, bringing together many high-end talents with unique creativity in software development and interface design.',
    intro2: 'We are committed to providing global enterprises with comprehensive solutions such as software development, website construction, web design, IT outsourcing, mobile application development, and internet marketing.',
    intro3: 'Headquartered in Serbia, Europe, our business spans multiple countries and regions including Europe, America, and China. We serve clients in various industries such as factories, department stores, e-commerce, education, clothing, trade, and manufacturing.',
    yearsExperience: 'Years of Industry Experience',
    clients: 'Served Clients',
    satisfaction: 'Client Satisfaction',
    team: 'Professional Team',
    banner: 'Banner',
    quotation: 'Quotation Mark',
    advantages: 'Core Advantages',
    whyChooseUs: '为什么选择我们',
    efficientDelivery: 'Efficient Delivery',
    efficientDesc: 'Agile development process ensures projects are delivered on time with high quality',
    qualityAssurance: 'Quality Assurance',
    qualityDesc: 'Strict quality control system, standardized code, excellent performance',
    globalService: 'Global Service',
    globalDesc: 'Multi-language support, 7×24 global technical service',
    security: 'Security & Reliability',
    securityDesc: 'Enterprise-level security standards, data encryption, privacy protection',
    services: 'Service Scope',
    ourServices: '我们的服务',
    softwareDev: 'Software Development',
    softwareDesc: 'Enterprise application development, SaaS platform, customized business management system development',
    softwareItems: ['Enterprise Management System', 'CRM/ERP System', 'Data Analysis Platform'],
    websiteDev: 'Website Construction',
    websiteDesc: 'Brand official website, e-commerce platform, responsive website design and development',
    websiteItems: ['Corporate Website', 'E-commerce Platform', 'Responsive Design'],
    mobileApp: 'Mobile Application',
    mobileDesc: 'iOS/Android native development, mini programs, cross-platform applications',
    mobileItems: ['iOS/Android Apps', 'WeChat Mini Programs', 'Flutter Cross-platform'],
    bigData: 'Big Data Services',
    bigDataDesc: 'Data collection, analysis, visualization, AI intelligent decision support',
    bigDataItems: ['Data Warehouse', 'BI Analysis', 'AI Algorithms'],
    uiDesign: 'UI/UX Design',
    uiDesc: 'User experience design, interface design, brand visual design',
    uiItems: ['Interface Design', 'Interaction Design', 'Brand VI'],
    itOutsourcing: 'IT Outsourcing Services',
    itOutsourcingDesc: 'Technical team outsourcing, on-site project development, long-term technical consultant',
    itOutsourcingItems: ['Talent Outsourcing', 'Project Outsourcing', 'Technical Consulting'],
    cases: 'Success Cases',
    successCases: '成功案例',
    ecommerce: 'E-commerce',
    ecommerceTitle: 'European Cross-border E-commerce Platform',
    ecommerceDesc: '100,000+ daily orders, multi-language support',
    education: 'Education',
    educationTitle: 'Online Education Platform',
    educationDesc: 'Serving 1 million+ students, zero lag in live streaming',
    factory: 'Factory',
    factoryTitle: 'Smart Factory Management System',
    factoryDesc: '30% increase in production efficiency, real-time data monitoring',
    departmentStore: 'Department Store',
    departmentStoreTitle: 'Chain Department Store Management System',
    departmentStoreDesc: 'Omni-channel sales, real-time inventory synchronization',
    clientsSection: 'Cooperating Clients',
    ourClients: '我们的客户',
    client1: 'Fortune 500 Companies',
    client2: 'Well-known E-commerce Platforms',
    client3: 'International Hotel Groups',
    client4: 'Key Universities',
    client5: 'Manufacturing Enterprises',
    client6: 'Biomedicine',
    ctaTitle: 'Looking Forward to Creating the Future with You',
    ctaDesc: 'Professional technical team, tailor-made digital solutions for you',
    contactUs: 'Contact Us Now',
    language: 'Language',
    chinese: '中文',
    english: 'English',
    // HomePage
    homeBanner1Title: 'Starlink Technology - Connecting the World, Creating the Future',
    homeBanner1Content: 'Focus on internet technology innovation, serving markets in Europe, America, and China',
    homeBanner2Title: 'Enterprise-level Digital Solution Expert',
    homeBanner2Content: 'From corporate websites to e-commerce platforms, from mini-programs to big data systems, one-stop solution for your digital needs',
    homeBanner3Title: 'Global Technical Team, Localized Attentive Service',
    homeBanner3Content: 'Bringing together top international technical talents, 7×24 hour全天候 response, keeping your business online forever',
    homeBanner4Title: 'Innovation Drives Development, Technology Leads the Future',
    homeBanner4Content: 'Deeply rooted in the internet technology field for many years, empowering enterprise digital transformation with technological innovation',
    homeBusinessTitle: 'Company Business Introduction',
    homeBusinessSubtitle: '我们的业务',
    homeBusinessDesc: 'Deeply engaged in the internet technology field for 15 years, providing comprehensive digital transformation solutions for enterprises',
    homeCompanyIntro: 'Starlink Technology is a global internet technology enterprise with business covering Europe, America, and China markets. We focus on providing digital transformation solutions for enterprises, helping clients build sustainable competitive advantages in the digital economy era.',
    homeCustomerPainPoints: 'Customer Pain Points',
    homePainPoint1: 'High customer acquisition cost: Traditional channel customer acquisition costs continue to rise, enterprise growth is weak',
    homePainPoint2: 'Low digitalization level: Business processes rely on manual work, low efficiency, high error rate',
    homePainPoint3: 'Serious data silos: Multiple systems, data cannot be interconnected, decision-making lacks basis',
    homePainPoint4: 'Poor user experience: Slow service response, insufficient personalization, serious customer churn',
    homeSolutions: 'Solutions',
    homeSolution1: 'Corporate website construction: Build professional brand image, improve search engine exposure, low-cost continuous customer acquisition',
    homeSolution2: 'Mini-program development: Relying on WeChat ecosystem, use and go, greatly improve user conversion and repurchase',
    homeSolution3: 'E-commerce platform customization: Omni-channel marketing system, intelligent order processing, helping business scale growth',
    homeSolution4: 'Big data system: Break through data silos, real-time analysis and decision-making, let data drive business growth',
    homeCoreValues: 'Core Values',
    homeValue1: 'Cost Reduction and Efficiency Improvement',
    homeValue2: 'Business Growth',
    homeValue3: 'Experience Upgrade',
    homeValue4: 'Data Driven',
    homeValue5: 'Continuous Innovation',
    homeServiceNetwork: 'Global Service Network | 7×24 Hour Technical Support | Full Lifecycle Service',
    homeServiceDetail: 'Learn About Service Details',
    homeITExpert: 'Your Neighboring IT Expert',
    homeITService: 'Providing Excellent IT Services 7x24 Hours',
    homeContactUs: 'Contact Us',
    homeCoreServices: 'Core Services',
    homeCoreServicesSubtitle: '核心服务',
    homeSoftwareDev: 'Software Development',
    homeSoftwareDevDesc: 'Enterprise applications, SaaS platforms, customized business management systems',
    homeSoftwareDevItems: ['Enterprise Management System', 'CRM/ERP System', 'Data Analysis Platform'],
    homeWebsiteDev: 'Website Construction',
    homeWebsiteDevDesc: 'Brand official website, e-commerce platform, responsive website design and development',
    homeWebsiteDevItems: ['Corporate Website', 'E-commerce Platform', 'Responsive Design'],
    homeMobileApp: 'Mobile Application',
    homeMobileAppDesc: 'iOS/Android native development, mini-programs, cross-platform applications',
    homeMobileAppItems: ['iOS/Android Apps', 'WeChat Mini Programs', 'Flutter Cross-platform'],
    homeBigData: 'Big Data Services',
    homeBigDataDesc: 'Data collection, analysis, visualization, AI intelligent decision support',
    homeBigDataItems: ['Data Warehouse', 'BI Analysis', 'AI Algorithms'],
    homeCustomerTestimonials: 'Customer Testimonials',
    homeCustomerTestimonialsSubtitle: '客户评价',
    homeWhyChooseUs: 'Why Choose Our Services',
    homeWhyChooseUsSubtitle: '选择我们的理由',
    homeGlobalService: 'Global Service Network',
    homeGlobalServiceDesc: 'Business covering Europe, America, and China\nLocalized team providing attentive service',
    homeTechnicalStrength: 'Strong Technical Strength',
    homeTechnicalStrengthDesc: 'Bringing together top industry technical talents\nYears of deep cultivation in the internet technology field',
    home247Support: '7×24 Hour Response',
    home247SupportDesc: 'Round-the-clock technical support and service\nQuick response to customer needs',
    homeOneStopSolution: 'One-stop Solution',
    homeOneStopSolutionDesc: 'From planning to development to operation and maintenance\nFull lifecycle service support',
    // ContactUs
    contactUs: 'Contact Us',
    companyName: 'Starlink Technology Co., Ltd.',
    lookingForward: 'Looking Forward to Creating the Future with You',
    address: 'Address',
    addressValue: 'Serbia, Europe',
    phone: 'Phone',
    phoneValue: '+381698925888',
    email: 'Email',
    emailValue: 'Starsunion.tech@gmail.com',
    workingHours: 'Working Hours',
    workingHoursValue: 'Monday to Friday 9:00 - 18:00',
    followUs: 'Follow Us',
    weixin: 'WeChat',
    weibo: 'Weibo',
    twitter: 'Twitter',
    // Service
    ourServices: 'Our Services',
    ourServicesEn: '我们的服务',
    service1: 'Corporate Website',
    service1En: '企业官网建设',
    service2: 'Ordering Mini Program',
    service2En: '下单小程序开发',
    service3: 'E-commerce Platform',
    service3En: '电商平台定制',
    service4: 'Big Data Management',
    service4En: '大数据管理系统',
    // Software
    softwareProducts: 'Software Products',
    software1: 'Smart Warehouse System',
    software1En: '智能仓储系统',
    software2: 'Cross-border E-commerce Platform',
    software2En: '跨境电商平台',
    software3: 'Corporate Official Website',
    software3En: '企业官方网站',
    software4: 'Immigration Consulting Platform',
    software4En: '移民咨询平台',
    software5: 'Cryptocurrency Trading System',
    software5En: '加密货币交易系统',
    software6: 'Restaurant Ordering Mini Program',
    software6En: '餐馆下单小程序',
    // NewsInformation
    newsInformation: 'News & Information',
    newsInformationEn: '新闻动态',
    allNews: 'All News',
    companyNews: 'Company News',
    industryNews: 'Industry News',
    readMore: 'Read More →',
    loadingMore: 'Load More',
    loading: 'Loading...',
    noMoreNews: 'No more news~',
    // Months
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    // JobChance
    jobChance: 'Job Opportunities',
    phpEngineer: 'PHP Engineer',
    jobResponsibilities: 'Job Responsibilities',
    jobResponsibility1: 'Responsible for the functional development and code optimization of the company\'s products and project systems;',
    jobResponsibility2: 'Responsible for the assignment and supervision of project team members\' tasks, and timely resolution of project technical issues;',
    jobResponsibility3: 'Participate in system requirement analysis and design, and be responsible for completing PHP core code, interface specification formulation, and architecture design.',
    jobRequirements: 'Job Requirements',
    jobRequirement1: 'Proficient in PHP+MySql+Apache development, proficient in using JavaScript, AJAX, JQuery and other technologies; more than 3 years of WEB application development experience, with experience in large websites or e-commerce websites preferred;',
    jobRequirement2: 'Familiar with jQuery, with development experience in AJAX, HTML, CSS, JAVASCRIPT, etc.;',
    jobRequirement3: 'Familiar with PHP template technology, framework technology and design patterns, experience in developing with php framework systems preferred, such as: phpcms, dedecms, etc.;',
    jobRequirement4: 'Proficient in database principles, proficient in MYSQL, understand Mongo, etc., and have relevant relational database design and development experience, understand Mysql database configuration management and performance optimization;',
    jobRequirement5: 'Familiar with common data structures and algorithms, with good programming habits and strong document writing ability;',
    jobRequirement6: 'Familiar with various WEB caching technologies, familiar with large website architecture and performance optimization;',
    jobRequirement7: 'Rich experience in the deployment, construction, optimization, and troubleshooting of website system architecture, experience in system architecture under high load and large access volume preferred.',
    submitResume: 'Submit Resume',
    // Software_smartWarehouse
    smartWarehouse: 'Smart Warehouse System',
    smartWarehouseEn: '星联智能仓储系统',
    smartWarehouseIntro: 'Intelligent warehouse management platform for modern logistics enterprises, integrating IoT, AI, big data and other technologies to realize automation, intelligence and visualization of warehouse operations, greatly improving warehouse operation efficiency.',
    coreFeatures: 'Core Features',
    feature1: 'Smart warehousing management: barcode/RFID automatic identification, intelligent shelf recommendation, quality inspection management',
    feature2: 'Real-time inventory monitoring: inventory warning, expiry date management, batch tracing, inventory management',
    feature3: 'Smart picking system: optimal path planning, wave picking, voice picking, light picking',
    feature4: 'Automation equipment integration: AGV scheduling, stacker control, conveyor line docking, robotic arm coordination',
    feature5: 'Outbound management: intelligent review, automatic packaging, logistics docking, shipping traceability',
    feature6: 'Data reports: operation analysis, KPI dashboard, predictive analysis, decision support',
    applicationScenarios: 'Application Scenarios',
    scenarios: 'Suitable for various warehousing scenarios such as e-commerce warehousing, third-party logistics, manufacturing raw material warehouses, cold chain logistics, cross-border bonded warehouses, etc.',
    consultNow: 'Consult Now',
    // Software_crossBorderEcommerce
    crossBorderEcommerce: 'Cross-Border E-commerce Platform',
    crossBorderEcommerceEn: '星联跨境电商平台',
    crossBorderEcommerceIntro: 'One-stop cross-border e-commerce solution that supports multiple languages, multiple currencies, multiple warehouses, integrates payment, logistics, customs clearance and other links, helping enterprises easily explore global markets.',
    feature7: 'Multi-language and multi-currency: support global mainstream language switching, real-time exchange rate settlement',
    feature8: 'Global product management: multi-warehouse management, intelligent inventory allocation, procurement management',
    feature9: 'Order processing: automatic order review, intelligent order splitting, order merging, abnormal order processing',
    feature10: 'Payment integration: PayPal, Stripe, Alipay International, WeChat Pay Global',
    feature11: 'Logistics tracking: docking with DHL, FedEx, UPS and other international logistics, full visualization',
    feature12: 'Customs clearance service: intelligent customs declaration, tax calculation, customs clearance status tracking',
    scenarios2: 'Suitable for various cross-border trade scenarios such as cross-border e-commerce B2C/B2B platforms, overseas warehouse integration, imported bonded e-commerce, export cross-border e-commerce, etc.',
    // Header Menu
    home: 'Home',
    softwareProducts: 'Software Products',
    services: 'Services',
    news: 'News',
    aboutUs: 'About Us',
    jobs: 'Jobs',
    contact: 'Contact Us',
    smartWarehouse: 'Smart Warehouse System',
    crossBorderEcommerce: 'Cross-Border E-commerce Platform',
    officialWebsite: 'Corporate Website',
    immigrationConsulting: 'Immigration Consulting Platform',
    cryptoExchange: 'Cryptocurrency Trading System',
    restaurantOrdering: 'Restaurant Ordering Mini Program',
    headerContact: 'Contact Us Now!',
    headerService: '7x24 Hours Service',
    // Footer
    companyAddress: 'Address: Serbia, Europe',
    companyTel: 'Tel: +381698925888',
    companyEmail: 'Email: Starsunion.tech@gmail.com',
    companyWechat: 'WeChat: SerbiaIT',
    copyright: 'Copyright © 2018 - {year} Starlink Technology. All rights reserved.',
    // CompanyIntroduction
    yearsExperience: 'Years of Industry Experience',
    // HomePage Customer Reviews
    customer1Title: 'CTO of a Multinational E-commerce Group',
    customer1Content: 'The e-commerce platform built by Starlink Technology is stable and efficient, supporting millions of daily orders. Their technical strength is trustworthy.',
    customer2Title: 'Head of a Well-known Education Institution',
    customer2Content: 'From demand communication to launch delivery, the Starlink team demonstrated extremely high professional quality, significantly improving the user experience of our online education platform.',
    customer3Title: 'Digital Director of a Manufacturing Enterprise',
    customer3Content: 'The big data management system helped us achieve real-time monitoring and intelligent analysis of production data, improving decision-making efficiency by more than 60%.',
    customer4Title: 'CEO of a Chain Retail Enterprise',
    customer4Content: 'After the corporate website reconstruction, the brand image was completely renewed, SEO rankings improved significantly, and customer inquiries increased by nearly double.',
    customer5Title: 'Founder of a Medical Health Platform',
    customer5Content: 'Starlink Technology\'s technical team responds quickly and solves problems promptly. They are our long-term and stable partners.',
    // NewsInformation
    news1Title: 'Starlink Technology Completes Series B Financing to Accelerate Global Expansion',
    news1Excerpt: 'The company announces the completion of Series B financing, focusing on expanding markets in Europe, America, and China, strengthening technology R&D investment, and enhancing global service capabilities.',
    news2Title: '2026 Global Software Development Trends Report Released',
    news2Excerpt: 'AI-assisted programming, low-code platforms, and cloud-native architecture have become the three mainstream trends. Enterprises need to adjust their technology strategies in a timely manner.',
    news3Title: 'Starlink Technology Establishes Strategic Cooperation with a Multinational E-commerce Group',
    news3Excerpt: 'The two parties will carry out in-depth cooperation in e-commerce platform customization, big data analysis and other fields, with expected annual transaction volume exceeding 1 billion yuan.',
    news4Title: 'Cloud Computing Market Size Expected to Exceed $1 Trillion by 2027',
    news4Excerpt: 'The global cloud computing market continues to grow rapidly, with enterprise cloud adoption rate exceeding 80%, and hybrid cloud becoming the mainstream deployment method.',
    news5Title: 'Artificial Intelligence Has Broad Application Prospects in the Enterprise Service Field',
    news5Excerpt: 'From intelligent customer service to data analysis, AI technology is reshaping the enterprise service market, expected to grow 5 times in the next three years.',
    news6Title: 'Starlink Smart Mini Program Platform Launched to Help Enterprise Digital Transformation',
    news6Excerpt: 'The newly launched smart mini program platform supports quick setup of various business scenarios such as ordering, e-commerce, and appointments.',
    news7Title: 'Starlink Technology Wins "Best Technical Service Provider of the Year" Award',
    news7Excerpt: 'With outstanding technical strength and high-quality services, Starlink Technology stood out among thousands of participating enterprises.',
    news8Title: 'Starlink Big Data Management System V3.0 Officially Released',
    news8Excerpt: 'The new version supports real-time processing of massive data, with performance improved by 300%, and a new AI intelligent analysis module added.',
    companyNews: 'Company News',
    industryNews: 'Industry News',
    // ServiceDetail
    featuredServices: 'Featured Services',
    serviceDetail: 'Related Services',
    service1Title: 'Corporate Website',
    service1EngTitle: '企业官网建设',
    service1Content: '<h3>Professional Corporate Website Construction Services</h3><p>Starlink Technology provides professional website construction services for enterprises, from brand planning, UI design to technical development and SEO optimization, creating official websites that showcase enterprise strength and enhance brand image. We have an experienced design and development team that has created high-quality official websites for many enterprises.</p><h3>Service Process</h3><p>Requirement communication → Solution design → UI design → Front-end development → Back-end development → Testing and launch → After-sales maintenance. We provide full-process services to ensure every link is精益求精, presenting you with the most perfect work.</p><h3>Service Advantages</h3><p>1. Professional design team, creating unique brand image<br>2. Responsive design, fully adapted to PC/mobile/tablet<br>3. SEO optimization, improving search engine rankings<br>4. Security protection, ensuring stable website operation<br>5. After-sales maintenance, 7x24 hour technical support</p>',
    service2Title: 'Mini Program Development',
    service2EngTitle: '小程序开发',
    service2Content: '<h3>Professional Mini Program Development Services</h3><p>Starlink Technology provides WeChat mini program development services, covering various types such as ordering mini programs, e-commerce mini programs, and appointment mini programs. With WeChat\'s庞大 user ecosystem, we help enterprises quickly acquire customers and improve conversion rates.</p><h3>Service Process</h3><p>Requirement analysis → Prototype design → UI design → Development implementation → Testing and acceptance → Launch and release → Operation and maintenance. We adopt agile development mode to ensure high-quality project delivery.</p><h3>Service Advantages</h3><p>1. No need to download, use and go<br>2. Relying on WeChat ecosystem, low customer acquisition cost<br>3. Short development cycle, fast launch<br>4. Good user experience, high conversion rate<br>5. Support for multiple marketing methods, helping business growth</p>',
    service3Title: 'E-commerce Platform Customization',
    service3EngTitle: '电商平台定制',
    service3Content: '<h3>Professional E-commerce Platform Customization Services</h3><p>Starlink Technology provides e-commerce platform customization services for enterprises, supporting multiple modes such as B2C, B2B, O2O, covering full-process functions such as product management, order processing, payment docking, and logistics tracking, helping enterprises quickly build exclusive e-commerce platforms.</p><h3>Service Process</h3><p>Business consultation → Solution design → System development → Integration testing → Online deployment → Training and delivery → Operation and maintenance support. We provide one-stop e-commerce solutions, so you have no worries.</p><h3>Service Advantages</h3><p>1. Support for multi-merchant, multi-warehouse, multi-currency<br>2. High concurrency architecture, supporting peak traffic<br>3. Omni-channel marketing tools, improving conversion rates<br>4. Data reports, helping business decisions<br>5. Docking with mainstream payment and logistics systems</p>',
    service4Title: 'Big Data System',
    service4EngTitle: '大数据系统',
    service4Content: '<h3>Professional Big Data System Construction Services</h3><p>Starlink Technology provides big data system construction services for enterprises, covering the entire process of data collection, storage, processing, analysis, and visualization, helping enterprises挖掘 data value and achieve data-driven decision-making.</p><h3>Service Process</h3><p>Requirement research → Solution design → System construction → Data access → Analysis modeling → Visualization display → Training and delivery. We have a senior big data team to provide you with professional data services.</p><h3>Service Advantages</h3><p>1. Support for multi-source data access<br>2. Distributed storage, massive data processing<br>3. Real-time computing, millisecond-level response<br>4. AI algorithms, intelligent analysis and prediction<br>5. Visualization dashboard, data at a glance</p>',
    // Software_bigData
    bigDataSystem: 'Big Data Management System',
    bigDataSystemEn: '星联大数据管理系统',
    bigDataIntro: 'One-stop big data analysis platform for enterprise users, integrating data collection, storage, processing, analysis, and visualization, helping enterprises discover data value and drive intelligent decision-making.',
    coreFeatures: 'Core Features',
    bigDataFeature1: 'Multi-source data collection: Support for multiple data source access including databases, APIs, logs, IoT devices, etc.',
    bigDataFeature2: 'Massive data storage: Distributed storage architecture, supporting efficient storage of PB-level data',
    bigDataFeature3: 'Real-time data processing: Streaming computing engine, millisecond-level data processing capability',
    bigDataFeature4: 'Intelligent data analysis: Built-in AI algorithm models, supporting predictive analysis and anomaly detection',
    bigDataFeature5: 'Visualization dashboard: Rich chart components, supporting custom data dashboards',
    bigDataFeature6: 'Permission management: Fine-grained data permission control to ensure data security',
    applicationScenarios: 'Application Scenarios',
    bigDataScenarios: 'Suitable for various business scenarios such as e-commerce data analysis, user behavior tracking, operation monitoring dashboard, financial risk control analysis, intelligent manufacturing monitoring, etc.',
    consultNow: 'Consult Now',
    // Software_cryptoExchange
    cryptoExchange: 'Cryptocurrency Exchange System',
    cryptoExchangeEn: '星联加密货币交易系统',
    cryptoExchangeIntro: 'Secure and reliable cryptocurrency trading platform, supporting multiple digital currency transactions, with high concurrency processing capability, multiple security protection, real-time market push and other professional functions.',
    cryptoFeature1: 'Multi-currency support: BTC, ETH, USDT and other mainstream currencies, supporting token issuance',
    cryptoFeature2: 'Trading engine: high concurrency matching, millisecond-level response, supporting spot/contract trading',
    cryptoFeature3: 'Security protection: cold and hot wallet isolation, multi-signature, DDoS protection, risk control system',
    cryptoFeature4: 'Market system: real-time K-line, depth chart, latest transactions, 24-hour market',
    cryptoFeature5: 'Wallet management: deposit and withdrawal, address management, fund transfer, reconciliation system',
    cryptoFeature6: 'Backend management: user management, order management, currency management, financial statements',
    cryptoScenarios: 'Suitable for digital currency exchanges, blockchain project parties, decentralized finance (DeFi), digital asset management and other scenarios.',
    // Software_immigrationConsulting
    immigrationConsulting: 'Immigration Consulting Platform',
    immigrationConsultingEn: '星联移民咨询平台',
    immigrationConsultingIntro: 'Professional immigration consulting service platform, integrating global immigration resources, providing one-stop services such as immigration assessment, program customization, and application progress tracking, helping clients realize their immigration dreams.',
    immigrationFeature1: 'Intelligent assessment system: online evaluation, condition assessment, success rate prediction, program recommendation',
    immigrationFeature2: 'Project display: immigration projects in various countries, policy interpretation, cost details, case display',
    immigrationFeature3: 'Customer management: customer files, follow-up records, demand analysis, label management',
    immigrationFeature4: 'Application management: material list, progress tracking, time node reminders, document management',
    immigrationFeature5: 'Online consultation: intelligent customer service, expert appointment, video consultation, message reply',
    immigrationFeature6: 'Information community: immigration information, policy interpretation, experience sharing, Q&A community',
    immigrationScenarios: 'Suitable for immigration agencies, study abroad immigration institutions, overseas property consulting, investment immigration services and other scenarios.',
    // Software_officialWebsite
    officialWebsite: 'Corporate Website',
    officialWebsiteEn: '星联企业官网建设',
    officialWebsiteIntro: 'Professional corporate website construction services, from brand planning, UI design to technical development, SEO optimization, creating official websites that showcase enterprise strength and enhance brand image.',
    officialFeature1: 'Brand visual design: corporate VI design, page UI design, responsive layout',
    officialFeature2: 'Content management system: news release, product display, case display, video center',
    officialFeature3: 'Multi-language support: Chinese/English/Japanese/Korean and other language versions, automatic language switching',
    officialFeature4: 'SEO optimization: search engine optimization, website speed optimization, mobile adaptation',
    officialFeature5: 'Security protection: SSL certificate, anti-SQL injection, DDoS protection, data backup',
    officialFeature6: 'Data statistics: access statistics, user behavior analysis, conversion tracking',
    officialScenarios: 'Suitable for various corporate websites, brand websites, group portals, product websites, service institution websites and other brand image display needs.',
    // Software_restaurantOrdering
    restaurantOrdering: 'Restaurant Ordering Mini Program',
    restaurantOrderingEn: '星联餐馆下单小程序',
    restaurantOrderingIntro: 'Smart catering solution, supporting QR code ordering, online payment, order management, kitchen printing and other functions, helping restaurants improve service efficiency and customer dining experience.',
    restaurantFeature1: 'QR code ordering: table QR code scanning, menu browsing, specification selection, shopping cart',
    restaurantFeature2: 'Intelligent recommendation: hot recommendations, set meal matching, taste preferences, historical orders',
    restaurantFeature3: 'Online payment: WeChat Pay, Alipay, membership card, coupons',
    restaurantFeature4: 'Order management: order status, production progress, call service, invoice application',
    restaurantFeature5: 'Kitchen system: automatic order receiving, partition printing, meal calling, return processing',
    restaurantFeature6: 'Backend management: dish management, inventory management, business reports, membership management',
    restaurantScenarios: 'Suitable for Chinese restaurants, Western restaurants, fast food restaurants, milk tea shops, coffee shops, food courts and other catering scenarios.',
    // Software_smartTown
    smartTown: 'Smart Town Management System',
    smartTownEn: '星联智能小镇管理系统',
    smartTownIntro: 'Intelligent comprehensive management platform for government and park managers, integrating IoT, big data, AI and other technologies to achieve digital management, intelligent services and visualized operation of towns/parks.',
    smartTownFeature1: 'Smart security monitoring: AI video analysis, face recognition, vehicle management, abnormal alarm',
    smartTownFeature2: 'Smart facility management: remote device monitoring, energy consumption analysis, intelligent inspection, fault early warning',
    smartTownFeature3: 'Enterprise service platform: enterprise entry management, policy matching, appeal acceptance, data analysis',
    smartTownFeature4: 'Smart investment system: investment project management, customer follow-up, contract management, data analysis',
    smartTownFeature5: 'Comprehensive command screen:全镇 data overview on one screen, emergency command and dispatch, decision support',
    smartTownFeature6: 'Mobile management terminal: handle affairs anytime, anywhere, receive alarms, view reports',
    smartTownScenarios: 'Suitable for digital management and intelligent upgrading of various parks such as science and technology parks, industrial parks, characteristic towns, business incubators, and logistics parks.'
  }
}

// 从 localStorage 获取保存的语言设置，如果没有则使用默认语言
const savedLocale = localStorage.getItem('locale') || 'zh'

const i18n = new VueI18n({
  locale: savedLocale, // 使用保存的语言或默认语言
  messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js